import React from 'react'
import DialogHeader from 'redesign/components/molecules/dialog-header'
import { DIALOG_SIZES } from '../../../molecules/dialog/constants'
import DrawerModal from '../../drawer-modal'
import ModalActionButtons from './modal-action-buttons'
import { Container } from './styles'
import type { InfoModalProps } from './types'

const InfoModal: React.FC<InfoModalProps> = ({
  headerLabel,
  isOpen,
  isSmallScreen,
  onClose,
  customZIndex,
  children,
}) => {
  const footer = isSmallScreen ? undefined : <ModalActionButtons onClose={onClose} />

  return (
    <DrawerModal
      header={<DialogHeader title={headerLabel} onClose={onClose} />}
      isOpen={isOpen}
      onClose={onClose}
      isSmallScreen={isSmallScreen}
      footer={footer}
      noPadding
      dialogSize={DIALOG_SIZES.medium}
      customZIndex={customZIndex}
    >
      <Container>{children}</Container>
    </DrawerModal>
  )
}

export default InfoModal
